import { useEffect, useState } from 'react';
import { elapsedSecs, readWorkoutTimer, type WorkoutTimerRecord } from '../workoutTimer';

/**
 * The header's workout clock. Re-reads localStorage on a tick and on `storage`
 * events, so starting or finishing a workout in one tab updates any other, and
 * a refresh picks the clock back up mid-workout.
 */
export function useWorkoutClock(): { record: WorkoutTimerRecord | null; seconds: number } {
  const [record, setRecord] = useState<WorkoutTimerRecord | null>(() => readWorkoutTimer());
  const [, setTick] = useState(0);

  useEffect(() => {
    const refresh = () => {
      setRecord(readWorkoutTimer());
      setTick(t => t + 1);
    };
    // A running clock needs a tick; a frozen one only needs storage events.
    const id = setInterval(refresh, 1000);
    window.addEventListener('storage', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearInterval(id);
      window.removeEventListener('storage', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);

  return { record, seconds: record ? elapsedSecs(record) : 0 };
}
